// Lead Contacts Management Permissions

export const LEADS_CONTACT_INDEX = 245;
export const LEADS_CONTACT_STORE = 246;
export const LEADS_CONTACT_EXPORT = 1347;
export const LEADS_CONTACT_SHOW = LEADS_CONTACT_INDEX;
export const LEADS_CONTACT_UPDATE = 248;
export const LEADS_CONTACT_DESTROY = 249;
export const LEAD_CONTACTS_RESTORE = 1402;
